import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslatePipe } from '@core/i18n';

@Component({
  selector: 'app-client-mobile-header',
  standalone: true,
  imports: [IonIcon, RouterLink, TranslatePipe],
  templateUrl: './client-mobile-header.component.html',
  styleUrl: './client-mobile-header.component.scss',
})
export class ClientMobileHeaderComponent {}
